import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { useManagerProfileContext } from "../../../manager/hooks/manager-profile/ManagerProfileContext";
import { formatReportDate, formatReportDateDistanceInWords } from "../../utils/TableCellDataFormatters";
const DateLabel = ({
  classes,
  value,
  includeSeconds = false,
  showDateOnly = false,
  showDistanceInWords = false,
  customFormat,
  showWarningColors = false,
  variant = "body1",
  typographyWrap = true,
  isMultipleDates = false
}) => {
  const {
    managerProfile: {
      timeZone,
      showDevDateTime
    }
  } = useManagerProfileContext();
  if (!showDistanceInWords || showDevDateTime) {
    const dateToDisplay = formatReportDate(value, {
      includeSeconds,
      showDateOnly,
      customFormat,
      showDevDateTime
    }, timeZone);
    if (typographyWrap) {
      return /*#__PURE__*/React.createElement(Typography, {
        color: "inherit",
        variant: variant
      }, dateToDisplay, `${isMultipleDates ? "," : ""}`);
    } else {
      return dateToDisplay;
    }
  }
  if (!value) {
    return "";
  }
  const {
    numberOfHours,
    formattedDate
  } = formatReportDateDistanceInWords(value, timeZone);
  let textClass = "";
  if (showWarningColors) {
    if (numberOfHours <= 5) {
      textClass = classes.amber;
    }
    if (numberOfHours < 0) {
      textClass = classes.red;
    }
  }
  if (typographyWrap) {
    return /*#__PURE__*/React.createElement(Typography, {
      color: "inherit",
      variant: variant,
      className: textClass
    }, formattedDate);
  } else {
    return formattedDate;
  }
};
const styles = () => ({
  amber: {
    color: "#fa9234"
  },
  red: {
    color: "#ff5d55"
  }
});
export default withStyles(styles)(DateLabel);
DateLabel.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  includeSeconds: PropTypes.bool,
  showDateOnly: PropTypes.bool,
  showDistanceInWords: PropTypes.bool,
  customFormat: PropTypes.string,
  showWarningColors: PropTypes.bool,
  variant: PropTypes.string,
  typographyWrap: PropTypes.bool,
  isMultipleDates: PropTypes.bool
};